import { useParams, useHistory } from 'react-router-dom';
import PermissionList from './PermissionList';
import { useRoleDetail } from '../Roles.hooks';
import Spin from 'Components/Spin/Spin';

function ViewRole() {
	const { roleId } = useParams<{ roleId: string }>();
	const history = useHistory();
	const { role, permissionList, loading } = useRoleDetail(roleId);

	if (loading || !role) return <Spin />

	return (
		<PermissionList
			mode="view"
			permissionList={permissionList}
			initialValues={{ roleName: role.role, description: role.description }}
			onCancel={() => history.goBack()}
		/>
	);
}

export default ViewRole;